import { create } from 'zustand'

export type GameZoneBalanceDisplay = 'USD'

type GameZonePreferencesState = {
  balanceDisplay: GameZoneBalanceDisplay
  isCurrencySelectionLocked: boolean
  hydrate: () => void
  setBalanceDisplay: (balanceDisplay: GameZoneBalanceDisplay) => void
  setCurrencySelectionLocked: (isLocked: boolean) => void
}

export const useGameZonePreferences = create<GameZonePreferencesState>((set) => ({
  balanceDisplay: 'USD',
  isCurrencySelectionLocked: false,
  hydrate: () => set({ balanceDisplay: 'USD' }),
  setBalanceDisplay: () => set({ balanceDisplay: 'USD' }),
  setCurrencySelectionLocked: (isCurrencySelectionLocked) => set({ isCurrencySelectionLocked }),
}))
